import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import TopBar from '../TopBar';

function ClubDetail() {
  return (
    <Box sx={{ pb: 7, maxWidth: '600px', margin: '0 auto', width: '100%' }}>
      <TopBar title="모임 상세" showBack={true} />
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2, color: '#666' }}>
          모임 상세 기능 준비 중입니다
        </Typography>
      </Box>
    </Box>
  );
}

export default ClubDetail;
